import { FormGroup } from '@angular/forms';
import { RANGE_SELECTED } from '@modules/reports/definitions/income-summary.constant';
import { RIF_REGEXP } from '@sharedValidators/regular-expresions.constant';
import * as dayjs from 'dayjs';

/**
 * @description ingresar mascara en un campo tipo texto.
 * @param d valor del input
 * @param sep separador
 * @param pat patron
 * @param nums bandera para decidir si admite valores no numericos
 */

export function mask(d: string, sep: string, pat: number[], nums: boolean, form: FormGroup, control: string): void {
  let val, val2, r, z, letra, val3, s, q;

  val = d;
  val = val.split(sep);
  val2 = '';
  for (r = 0; r < val.length; r++) {
    val2 += val[r];
  }

  if (nums) {
    for (z = 0; z < val2.length; z++) {
      if (isNaN(Number(val2.charAt(z)))) {
        letra = new RegExp(val2.charAt(z), 'g');
        val2 = val2.replace(letra, '');
      }
    }
  }

  val = '';
  val3 = new Array();

  for (s = 0; s < pat.length; s++) {
    val3[s] = val2.substring(0, pat[s]);
    val2 = val2.substring(pat[s]);
  }

  for (q = 0; q < val3.length; q++) {
    if (q == 0) {
      val = val3[q];
    } else {
      if (val3[q] != '') {
        val += sep + val3[q];
      }
    }
  }
  d = val;

  form.get(control)?.setValue(d.toUpperCase());
}

/**
 *
 * @param value this value to format string
 * @description format number to string
 * @returns {string} - return string number formatted
 * @example numberFormat(1000) => 1.000,00
 */
export function numberFormat(value: number): string {
  value = Math.round(Number(value) * 100) / 100;

  if (value === 0) {
    return '0,00';
  }
  if (value < 0 && value <= -0.01) {
    return '0,00';
  }
  if (value < 1) {
    return new Intl.NumberFormat('de-DE').format(value);
  } else {
    return stringToFloatString(new Intl.NumberFormat('de-DE').format(Number(value.toFixed(2))));
  }
}

/**
 *
 * @param str this string number to format evaluation
 * @returns {string} - return string number formatted
 * @example stringToFloatString('1000') => 1.000,00
 */
export function stringToFloatString(str: string): string {
  if (str.indexOf(',') == -1) {
    str = `${str},00`;
  } else {
    let auxArray = str.split(',');
    if (auxArray[1].length == 1) {
      str = `${str}0`;
    }
  }
  return str;
}

/**
 *
 * @param rif V-18763604-1 or V187636041
 * @description evaluation if the rif is valid
 * @returns {boolean} - return `true` if the RIF is valid, else `false`.
 * @example
 * // Ejemplo de uso:
 * isValidRIF('V-18763604-1'); // true
 */
export function isValidRIF(rif: string): boolean {
  return RIF_REGEXP.test(rif);
}

export const rifPattern = new Array(1, 8, 1);

export const tlfPattern = new Array(4, 3, 2, 2);

export const onlyNumberPattern = new Array(50, 0);

export function markInvalidControls(formGroup: FormGroup) {
  Object.keys(formGroup.controls).forEach((key) => {
    const control = formGroup.get(key);
    if (control && control.invalid) {
      control.markAsDirty();
    }
  });
}

export function maskUpperCaseInputs(event: any) {
  const input = event.target as HTMLInputElement;
  const start = input.selectionStart;
  const end = input.selectionEnd;
  input.value = input.value.toUpperCase();
  input.setSelectionRange(start, end);
}

/**
 * Prints the content of an HTML element specified by its ID.
 *
 * @param {string} elementId - The ID of the HTML element whose content you want to print.
 * @param {string} [title=''] - The title to be displayed in the print window and in the header of the printed content.
 * @param {string} [description=''] - An optional description to be displayed below the title in the printed content.
 * @returns {Promise<void>} - A promise that resolves when the print operation is complete.
 *
 * @example
 * // Call the print method to print the content of the element with ID 'tbl-income-summary'
 * print('tbl-income-summary', 'Income Summary', 'Description of the income summary');
 *
 * @throws {Error} - Throws an error if there is a problem converting the image to base64 or opening the print window.
 */
export async function print(elementId: string, title = '', description = ''): Promise<void> {
  const printContent = document.getElementById(elementId);
  if (printContent) {
    try {
      const imageUrl = 'assets/images/sign-in/logo.png';
      const logoBase64 = await convertImageToBase64(imageUrl);

      const WindowPrt = window.open('', '', 'width=900,height=650');
      if (WindowPrt) {
        WindowPrt.document.write(`<html><head><title>${title}</title>`);
        WindowPrt.document.write('</head><body>');
        WindowPrt.document.write(`<img style="width: 200px; height: auto;" src="${logoBase64}" alt="logo"/>`);
        WindowPrt.document.write(`<h2 style="text-align:center">${title}</h2>`);
        WindowPrt.document.write(`<h3>${description}</h3>`);
        WindowPrt.document.write(`
          <style>
            table {
              width: 100%;
              border: 1px solid black;
              border-collapse: collapse;
            }
            th, td {
              border: 1px solid black;
              padding: 8px;
              text-align: center;
            }
            .hidden-cel {
              border: none !important;
              visibility: hidden;
            }
            .display-none-cel{
              display: none;
            }
          </style>
        `);

        // Modifica el contenido HTML para agregar la clase "no-border" al td deseado
        const modifiedContent = printContent.outerHTML.replace(
          '<td class="py-2 px-4 text-right font-bold">Total</td>',
          '<td class="py-2 px-4 text-right font-bold no-border">Total</td>',
        );

        WindowPrt.document.write(modifiedContent);
        WindowPrt.document.write('</body></html>');
        WindowPrt.document.close();

        // Delay antes de imprimir
        setTimeout(() => {
          WindowPrt.focus();
          WindowPrt.print();
          WindowPrt.close();
        }, 500); // Delay de 500 ms (ajustable según sea necesario)
      }
    } catch (error) {
      console.error('Error printing the content:', error);
    }
  }
}

export function search(tableId: string, searchInputId: string) {
  // Declare variables
  let input, filter, table, tr, td, i, j, txtValue;
  input = document.getElementById(searchInputId) as HTMLInputElement;
  filter = input.value.toUpperCase();
  table = document.getElementById(tableId) as HTMLTableElement;
  tr = table.getElementsByTagName('tr');

  // Loop through all table rows, and hide those who don't match the search query
  for (i = 1; i < tr.length; i++) {
    // Start from 1 to skip the header row
    tr[i].style.display = 'none'; // Hide the row initially
    td = tr[i].getElementsByTagName('td');
    for (j = 0; j < td.length; j++) {
      if (td[j]) {
        txtValue = td[j].textContent || td[j].innerText;
        if (txtValue.toUpperCase().indexOf(filter) > -1) {
          tr[i].style.display = ''; // Show the row if any cell matches the filter
          break; // Stop checking other cells in the same row
        }
      }
    }
  }
}

export function getTotal(field: string, array: any[]): number {
  return array.reduce((sum: number, item: any) => {
    const fields = field.split('.');
    let value = item;
    for (const f of fields) {
      value = value[f];
      if (value === undefined) {
        return sum;
      }
    }
    return sum + Number(value);
  }, 0);
}

/**
 * Converts an image from a given URL to a Base64-encoded string.
 *
 * @param {string} imageUrl - The URL of the image to be converted.
 * @returns {Promise<string>} - A promise that resolves to the Base64-encoded string of the image.
 *
 * @example
 * // Call the convertImageToBase64 method to convert an image to Base64
 * convertImageToBase64('assets/images/sign-in/logo.png')
 *   .then(base64String => {
 *     console.log(base64String);
 *   })
 *   .catch(error => {
 *     console.error('Error converting image to Base64:', error);
 *   });
 *
 * @throws {Error} - Throws an error if there is a problem fetching the image or converting it to Base64.
 */
export async function convertImageToBase64(imageUrl: string): Promise<string> {
  try {
    // Fetch the image as a Blob
    const response = await fetch(imageUrl);
    if (!response.ok) {
      throw new Error(`Error fetching the image: ${response.statusText}`);
    }
    const blob = await response.blob();

    // Convert the Blob to Base64
    return await new Promise<string>((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result as string); // Base64 string
      reader.onerror = () => reject(new Error('Failed to convert image to Base64'));
      reader.readAsDataURL(blob);
    });
  } catch (error) {
    console.error('Error converting image to Base64:', error);
    throw error;
  }
}

/**
 * @description get current period
 * @returns {string} - return current period
 * @example currentPeriod() => 2022-09-01
 */
export function currentPeriod(): string {
  return dayjs().format('YYYY-MM-01').toUpperCase();
}

export function openWndown(url: string): void {
  window.open(url, '_blank');
}

export function jsonParseSafe(data: string): JSON | string {
  let element = data;
  if (typeof data === 'string') {
    try {
      element = JSON.parse(data);
      if (typeof element === 'string') {
        element = JSON.parse(element);
      }
    } catch (e) {
      // Si falla el parseo, deja el valor original
    }
  }
  return element;
}

export function actionEvents(
  evt: { type: 'search' | 'setForm'; form: FormGroup },
  form: FormGroup,
  method: (form: FormGroup) => void,
): void {
  if (evt.type === 'search') {
    method(evt.form);
  }
  if (evt.type === 'setForm') {
    form = evt.form;
    if (RANGE_SELECTED.startDate && RANGE_SELECTED.endDate) {
      form.patchValue(RANGE_SELECTED);
      method(form);
    }
  }
}

// Convierte un texto a Title Case (primera letra en mayúscula por palabra)
export function toTitleCase(value: string | undefined | null): string {
  if (!value) return '';
  return value
    .toString()
    .toLowerCase()
    .split(/\s+/)
    .map((word) => (word.length ? word[0].toUpperCase() + word.slice(1) : ''))
    .join(' ')
    .trim();
}

// Blob download
export function downloadBlob(blob: Blob, fileName: string): void {
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = fileName;
  a.click();
  window.URL.revokeObjectURL(url);
}
